function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from 'react';
import { Table, Form, Button, DatePicker, Select, message, Divider, Skeleton, Collapse } from 'antd';
import { Container, Row, Col } from 'react-bootstrap';
import Common from './includes/Common';
import dayjs from 'dayjs';
import Moment from 'react-moment';
import moment from 'moment';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var RangePicker = DatePicker.RangePicker;
var CashTransactionHistory = function CashTransactionHistory(_ref) {
  var cashBox = _ref.cashBox;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    transactionList = _useState2[0],
    setTransactionList = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    transactionArrayData = _useState4[0],
    setTransactionArrayData = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    agentOptions = _useState6[0],
    setAgentOptions = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isFormLoading = _useState8[0],
    setIsFormLoading = _useState8[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var cols = [{
    title: /*#__PURE__*/_jsx("b", {
      children: "Date"
    }),
    dataIndex: 'date',
    key: 'date',
    render: function render(text) {
      return /*#__PURE__*/_jsx(Moment, {
        date: text,
        format: "DD/MM/YYYY"
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Montant"
    }),
    dataIndex: 'amount',
    key: 'amount',
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text.toLocaleString('Fr')
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "E/S"
    }),
    dataIndex: 'operation_type',
    key: 'operation_type',
    render: function render(type) {
      return /*#__PURE__*/_jsx("b", {
        children: type
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Cat\xE9gorie"
    }),
    dataIndex: 'expense_category',
    responsive: ['lg', 'md', 'sm'],
    key: 'expense_category',
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Auteur"
    }),
    dataIndex: 'user',
    key: 'user',
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Commentaire"
    }),
    responsive: ['lg', 'md'],
    dataIndex: 'comment',
    key: 'comment',
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    }
  }];
  var onFinish = function onFinish(values) {
    setIsFormLoading(true);
    var request = values.agent_id == 0 ? axios.get("".concat(Common.baseApiUrl, "getcashtransactions/").concat(cashBox.id.toString(), "/").concat(Common.currentUser.id, "/").concat(moment(values.period[0].$d).format(), "/").concat(moment(values.period[1].$d).format())) : axios.get("".concat(Common.baseApiUrl, "getpumpreports/").concat(values.agent_id, "/").concat(Common.currentUser.id, "/").concat(moment(values.period[0].$d).format(), "/").concat(moment(values.period[1].$d).format()));
    request.then(function (response) {
      if (response.data.status == 200) {
        setTransactionArrayData([]);
        setTransactionList(response.data.reports);
        response.data.reports.forEach(function (r) {
          setTransactionArrayData(function (prev) {
            var _ref2;
            return [].concat(_toConsumableArray(prev), [(_ref2 = {
              key: r.id,
              date: r.created_at,
              expense_category: r.operation_type == 0 && r.expense_category != null ? r.expense_category.label : "--",
              operation_type: r.operation_type == 0 ? "SORTIE" : "ENTREE",
              amount: r.amount
            }, _defineProperty(_ref2, "operation_type", r.operation_type == 0 ? /*#__PURE__*/_jsx("b", {
              style: {
                color: '#A64839'
              },
              children: "ENTREE"
            }) : /*#__PURE__*/_jsx("b", {
              style: {
                color: '#39A670'
              },
              children: "SORTIE"
            })), _defineProperty(_ref2, "user", "".concat(r.user.prenom, " ").concat(r.user.nom)), _defineProperty(_ref2, "comment", r.comment), _ref2)]);
          });
        });
      } else {
        message.error({
          content: 'Une erreur est survenue',
          delay: 4
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    })["finally"](function () {
      setIsFormLoading(false);
    });
  };
  useEffect(function () {
    axios.all([axios.get(Common.baseApiUrl + "getplatformusers/" + Common.currentUser.id), axios.get("".concat(Common.baseApiUrl, "getcashtransactions/").concat(cashBox.id.toString(), "/").concat(Common.currentUser.id, "/").concat(moment().startOf('day').format(), "/").concat(moment().endOf('day').format()))]).then(function (response) {
      if (response[0].data.status == 200) {
        setAgentOptions(function (prev) {
          return [].concat(_toConsumableArray(prev), [{
            label: 'Tous les agents',
            value: 0
          }]);
        });
        response[0].data.users.filter(function (u) {
          return u.role == 401;
        }).forEach(function (u) {
          setAgentOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              label: u.prenom + " " + u.nom,
              value: u.id
            }]);
          });
        });
        form.setFieldsValue({
          agent_id: 0
        });
      } else {
        message.error({
          content: 'Une erreur est survenue',
          delay: 4
        });
      }
      if (response[1].data.status == 200) {
        setTransactionArrayData([]);
        setTransactionList(response[1].data.reports);
        response[1].data.transactions.forEach(function (r) {
          setTransactionArrayData(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              key: r.id,
              date: r.created_at,
              expense_category: r.operation_type == 0 && r.expense_category != null ? r.expense_category.label : "--",
              amount: r.amount,
              operation_type: r.operation_type == 0 ? /*#__PURE__*/_jsx("b", {
                style: {
                  color: '#A64839'
                },
                children: "SORTIR"
              }) : /*#__PURE__*/_jsx("b", {
                style: {
                  color: '#39A670'
                },
                children: "ENTREE"
              }),
              user: "".concat(r.user.prenom, " ").concat(r.user.nom),
              comment: r.comment
            }]);
          });
        });
      } else {
        message.error({
          content: 'Une erreur est survenue',
          delay: 4
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue ',
        delay: 4
      });
    })["finally"](function () {});
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Form, {
      onFinish: onFinish,
      form: form,
      size: "large",
      children: /*#__PURE__*/_jsxs(Container, {
        children: [/*#__PURE__*/_jsx(Collapse, {
          ghost: true,
          items: [{
            key: '1',
            label: /*#__PURE__*/_jsx("b", {
              children: " Filtrer"
            }),
            children: /*#__PURE__*/_jsx(_Fragment, {
              children: /*#__PURE__*/_jsxs(Row, {
                children: [/*#__PURE__*/_jsx(Col, {
                  lg: 3,
                  md: 4,
                  children: /*#__PURE__*/_jsx(Form.Item, {
                    name: "period",
                    rules: [{
                      required: true,
                      message: 'Ce champ est obligatoire'
                    }],
                    children: /*#__PURE__*/_jsx(RangePicker, {
                      showTime: true,
                      format: "DD/MM/YYYY HH:mm:ss",
                      presets: [{
                        label: 'Hier',
                        value: dayjs().add(-1, 'd')
                      }, {
                        label: "Aujourdh'hui",
                        value: dayjs().add(0, 'd')
                      }]
                    })
                  })
                }), /*#__PURE__*/_jsx(Col, {
                  lg: 3,
                  md: 4,
                  children: /*#__PURE__*/_jsx(Form.Item, {
                    name: "agent_id",
                    rules: [{
                      required: true,
                      message: 'Ce champ est obligatoire'
                    }],
                    children: /*#__PURE__*/_jsx(Select, {
                      options: agentOptions
                    })
                  })
                }), /*#__PURE__*/_jsx(Col, {
                  lg: 2,
                  md: 2,
                  children: /*#__PURE__*/_jsx(Form.Item, {
                    children: /*#__PURE__*/_jsx(Button, {
                      loading: isFormLoading,
                      type: "primary",
                      htmlType: "submit",
                      children: /*#__PURE__*/_jsx("b", {
                        children: "RECHERCHE"
                      })
                    })
                  })
                })]
              })
            })
          }]
        }), /*#__PURE__*/_jsx(Table, {
          columns: cols,
          dataSource: transactionArrayData,
          bordered: true,
          size: "small"
        })]
      })
    })
  });
};
export default CashTransactionHistory;